/**
 * Component Registry for Somerset Oaks Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-preferred/registry';
import { Gallery } from './components/Gallery';
import { SisterProperties } from './components/SisterProperties';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Gallery,
  SisterProperties,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
